export default {
  app: {
    featured: 'Featured',
    random: 'Random',
    explore: 'Explore',
    keywords: 'Keywords',
    search: 'Search',
  },
  explore: {
    filters: 'Filters',
    resetFilters: 'Reset Filters',
    addKeyword: 'Add Keyword',
  },
  recipe: {
    contributedBy: 'Contributed By',
    ingredients: 'Ingredients',
    directions: 'Directions',
    fullRecipe: 'View full recipe at',
    similarDrinks: 'Similiar drinks',
  },
  featuredRecipes: {
    loadMore: 'Load More',
  },
  recipeFind: {
    filterBy: 'Filter by',
    name: 'Name',
    ingredients: 'Ingredients',
    keywords: 'Keywords',
    searchForIngredients: 'You can search for multiple ingredients by separating them with a space',
    searchForKeywords: 'You can search for multiple keywords by separating them with a space',
  },
  recipeList: {
    viewRecipe: 'View Recipe',
  },
  recipeToolbar: {
    print: 'Print',
    share: 'Share',
    shareOnFacebook: 'Share on Facebook',
    shareOnTwitter: 'Share on Twitter',
    copyURL: 'Copy URL',
    hideImage: 'Hide Image',
    setFavorite: 'Set Favorite',
    unsetFavorite: 'Unset Favorite',
    urlCopied: 'URL Copied!',
    urlCopiiedInClipboard: 'The URL is copied in your clipboard',
  },
  keywordList: {
    enterYourKeyword: 'Enter your Keyword',
  },
  favorites: {
    removeAllFavorites: 'Remove All Favorites',
    noFavoriteDrinks: "You don't have any favorite drinks",
    removeFavoritesPrompt: 'Are you sure you want to remove all favorites',
    delete: 'Delete',
    cancel: 'Cancel',
  },
  search: {
    findYourDrink: 'Find Your Drink',
  },
  pageNotFound: {
    pageNotFound: 'The page you are looking for was not found.',
    backToHome: 'Back to Home',
  },
};
